import util from '@/libs/util.js'
import { getToken } from '@/libs/util.token'

export default {
  methods: {
    // eslint-disable-next-line no-unused-vars
    handleMenuSelect(index, indexPath) {
      if (/^d2-menu-empty-\d+$/.test(index) || index === undefined) {
        this.$message.warning('临时菜单')
      } else if (/^local:/.test(index)) {
        location.href = index.replace('local:', '')
      } else if (/^https:\/\/|http:\/\//.test(index)) {
        index.replace('{token}', '?token=' + getToken() || '')
        util.open(index)
      } else {
        this.$router.push({
          path: index
        })
      }
    }
  }
}
